import { Route } from '@angular/router';
import { MarketFilesComponent } from './market-files/market-files.component';
import { MarketListComponent } from './market-list/market-list.component';
import { MarketReportComponent } from './market-report/market-report.component';

export const marketRoutes: Route[] = [
  { path: 'pricing/report', component: MarketReportComponent },
  { path: 'pricing/files', component: MarketFilesComponent },
  { path: 'pricing', component: MarketListComponent },
  { path: 'pricing/list', component: MarketListComponent }
];
